/* VersionControlDetailsViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./VersionControlDetailsViewRenderer");

class VersionControlDetailsViewComponent extends EventEmitter {
    constructor(logger, gameEditor, userSession, MUF) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._modalUserFeedback = MUF;

        this._config = this._gameEditor.config;

        this._activeOrgId = userSession.activeOrganization.id;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    get formConfig() {
        return {
            displayType: {
                label: "Item",
                dataType: "string",
                categories: ["entity", "construct"],
            },
            displayTypeName: {
                label: "Construct Type",
                dataType: "string",
                categories: ["construct"],
            },
            displayFeatureType: {
                label: "Storage Type",
                dataType: "string",
                categories: ["construct"],
            },
            displayFeatureInstance: {
                label: "Feature",
                dataType: "string",
                categories: ["construct"],
            },
            name: {
                label: "Name",
                dataType: "string",
                categories: ["entity", "construct"],
            },
            description: {
                label: "Description",
                dataType: "string",
                categories: ["entity", "construct"],
            },
            updatedOn: {
                label: "Date",
                dataType: "datetime",
                categories: ["entity", "construct"],
            },
            updatedBy: {
                label: "Author",
                dataType: "string",
                categories: ["entity", "construct"],
            },
        };
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get gameEditor() {
        return this.getGameEditor();
    }
    getGameEditor() {
        return this._gameEditor;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._gameEditor = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._activeOrgId = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn(err, "VersionControlDetailsViewComponent.shutdown() error.");
            }
        );
    }

    get logger() {
        return this.getLogger();
    }
    getLogger() {
        return this._logger;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _getJType() {
        return Object.entries(this.formConfig).reduce((acc, [fieldId, fieldConfig]) => {
            if ((fieldConfig.categories || []).includes(this._config.category)) {
                acc[fieldId] = "";
                acc[`${fieldId}@Display.label`] = fieldConfig.label;
                acc[`${fieldId}@Display.readOnly`] = true;
            }
            return acc;
        }, {});
    }

    _getPristineValues() {
        return Object.entries(this.formConfig).reduce((acc, [fieldId, fieldConfig]) => {
            if (fieldConfig.dataType === "datetime") {
                acc[fieldId] = dateString(this._config[fieldId]);
            } else {
                acc[fieldId] = this._config[fieldId];
            }

            return acc;
        }, {});

        function dateString(timeStamp) {
            const date = new Date(timeStamp);
            return date.isValid()
                ? date.toLocaleDateString() + " " + date.toLocaleTimeString()
                : "";
        }
    }

    get jType() {
        return this._getJType();
    }

    get pristineValues() {
        return this._getPristineValues(this._osImage);
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenEditorIsReady()
            .then(() => {
                // this._registerListeners();
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn(
                    err,
                    "VersionControlDetailsViewComponent.whenModelIsReady() error"
                );
                this._modalUserFeedback.displayError({
                    errorMsg: "This configuration cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = VersionControlDetailsViewComponent;

VersionControlDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
];

VersionControlDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "Version Details",
    icon: "configdrift.device_details",
    shown: true,
    title: "Details",
    order: 1,
};
